module.exports = __webpack_public_path__ + "img/background-video-slider-v2-cjdr.49da7dbf.png";